import React from "react";

const overlayStyle = {
    position: "fixed",
    inset: 0,
    background: "rgba(0, 0, 0, 0.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    padding: "24px",
};

const dialogStyle = {
    width: "100%",
    maxWidth: "520px",
    background: "#fff",
    borderRadius: "8px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
    overflow: "hidden",
};

const headerStyle = {
    padding: "20px 24px 14px",
    fontSize: "20px",
    fontWeight: 600,
    borderBottom: "1px solid #e5e5e5",
};

const bodyStyle = {
    padding: "24px",
    fontSize: "15px",
    lineHeight: 1.5,
    color: "#333",
};

const actionsStyle = {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    padding: "16px 24px 20px",
    borderTop: "1px solid #e5e5e5",
};

const ConfirmDialog = ({
                           open,
                           title = "Confirm",
                           message = "Are you sure?",
                           confirmText = "Yes",
                           cancelText = "No",
                           onConfirm,
                           onCancel,
                           confirmClassName = "ui red button",
                           cancelClassName = "ui button",
                       }) => {
    if (!open) return null;

    return (
        <div style={overlayStyle} onClick={onCancel}>
            <div style={dialogStyle} onClick={(e) => e.stopPropagation()}>
                <div style={headerStyle}>{title}</div>

                <div style={bodyStyle}>{message}</div>

                <div style={actionsStyle}>
                    <button
                        type="button"
                        className={cancelClassName}
                        onClick={onCancel}
                        style={{ minWidth: "88px" }}
                    >
                        {cancelText}
                    </button>

                    <button
                        type="button"
                        className={confirmClassName}
                        onClick={onConfirm}
                        style={{ minWidth: "88px" }}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDialog;